import React from 'react';
import LineConf from './LineConfig'


const LineSection = (props) => {
  return (
    <>
      <div className='line-config-top primary-color'>
        <div className='line-tag-container'>
          <h2>Indicador</h2>
        </div>
        <div className='add-button'>
          <i className='fas fa-plus on-mouse-hover' onClick={props.addLine}></i>
        </div>
      </div>
      {
        props.state.lines.map((line, i) => <LineConf props={props} line={line} key={'line-key-' + i}/>)
      }
    </>
  )
}

export default LineSection;